<template>
  <div class="breadcrumb-wrap">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-8 col-sm-8">
          <div class="breadcrumb-title">
            <h2>{{ pageTitle }}</h2>
            <ul class="breadcrumb-menu list-style">
              <li>
                <router-link to="/">Home </router-link>
              </li>
              <li>{{ mainTitle }}</li>
            </ul>
          </div>
        </div>

        <div class="col-lg-6 col-md-4 col-sm-4">
          <div class="breadcrumb-img">
            <img
              src="../../assets/images/breadcrumb/breadcrumb-img-1.png"
              alt="Image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageBanner",
  props: ["pageTitle", "mainTitle"],
});
</script>